import React from 'react';
import Backdrop from '@mui/material/Backdrop';
import useStore from '../../store/store';
import './spinner.css';
import { Store } from '../../store/types';

const Spinner = () => {
    const spinner = useStore((state: Store) => state.spinner);
    return (
        <Backdrop
            sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
            open={spinner}
        >
            <div className="loader">Loading...</div>
        </Backdrop>
    );
};

export default Spinner;
